import React, {useRef, useState} from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faImages} from '@fortawesome/pro-regular-svg-icons';
import {IImageUploadModalProps} from './AddNewDataPointForm.types';
import {ACCEPTED_IMAGE_TYPES} from './AddNewDataPointForm.constants';

export const ImageUploadModal: React.FC<IImageUploadModalProps> = ({
  open,
  uploadedImages,
  onClose,
  onSave,
  onFilesSelected,
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);
    onFilesSelected(e.dataTransfer.files);
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onFilesSelected(e.target.files);
    if (e.target) {
      e.target.value = '';
    }
  };

  return (
    <>
      <input
        type="file"
        ref={fileInputRef}
        accept={ACCEPTED_IMAGE_TYPES.join(',')}
        multiple
        style={{display: 'none'}}
        onChange={handleFileInputChange}
      />
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{style: {borderRadius: 12}}}
      >
        <DialogTitle style={{fontWeight: 600}}>Upload your image</DialogTitle>
        <DialogContent>
          <Typography
            variant="body2"
            color="textSecondary"
            style={{marginBottom: 16}}
          >
            Recommended size 1080px by 1080px
          </Typography>
          <Box
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onClick={() => fileInputRef.current?.click()}
            style={{
              border: `2px dashed ${isDragging ? '#2D9B73' : '#ccc'}`,
              borderRadius: 12,
              padding: 32,
              textAlign: 'center',
              cursor: 'pointer',
              backgroundColor: isDragging
                ? 'rgba(45, 155, 115, 0.08)'
                : '#fafafa',
            }}
          >
            <FontAwesomeIcon
              icon={faImages}
              style={{fontSize: 48, color: '#999', marginBottom: 12}}
            />
            <Typography variant="body1" color="textSecondary">
              Drag and drop your images here or browse
            </Typography>
            {uploadedImages.length > 0 && (
              <Typography
                variant="body2"
                style={{marginTop: 8, color: '#2D9B73', fontWeight: 500}}
              >
                {uploadedImages.length} file(s) selected
              </Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions style={{padding: 16}}>
          <Button onClick={onClose} style={{textTransform: 'none'}}>
            Cancel
          </Button>
          <Button
            variant="contained"
            style={{
              backgroundColor: '#2D9B73',
              color: '#fff',
              textTransform: 'none',
              fontWeight: 600,
            }}
            onClick={onSave}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
